import {
  // createAction,
  handleActions
} from "redux-actions";
import moment from "moment";

import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS,
  SET_TABLE_LOADING,
  UPDATE_DATE,
  UPDATE_GROUP_BY_REVENUE_CATEGORY,
  UPDATE_INCLUDE_ZERO_SALES
} from "../sagas/membershipBreakdown/membershipBreakdown";
// Name Spaced Action Types
// Name Spaced Action Types
export const actions = {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS,
  SET_TABLE_LOADING
};

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
export const actionCreators = {};

export const initialState = {
  currentUser: {
    params: {
      theme: ""
    }
  },
  membershipsInfo: {},
  membershipsPieChartValues: [],
  membershipsPercentagesByProductName: {},
  totalMembersCount: {},
  date: moment().format("YYYY-MM-DD"),
  groupByRevenueCategory: true,
  includeZeroSales: true,
  isLoading: true,
  tableLoading: false
};

export default handleActions(
  {
    [UPDATE_DATE]: (state, action) => ({
      ...state,
      date: action.payload
    }),
    [UPDATE_GROUP_BY_REVENUE_CATEGORY]: state => ({
      ...state,
      groupByRevenueCategory: !state.groupByRevenueCategory
    }),
    [UPDATE_INCLUDE_ZERO_SALES]: state => ({
      ...state,
      includeZeroSales: !state.includeZeroSales
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload || state.isLoading
    }),
    [SET_TABLE_LOADING]: (state, action) => ({
      ...state,
      tableLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS]: (state, action) => ({
      ...state,
      date: action.payload.date || state.date,
      membershipsInfo: action.payload.membershipsInfo || state.membershipsInfo,
      membershipsPieChartValues: action.payload.membershipsPieChartValues || state.membershipsPieChartValues,
      membershipsPercentagesByProductName: action.payload.membershipsPercentagesByProductName || state.membershipsPercentagesByProductName,
      totalMembersCount: action.payload.totalMembersCount || state.totalMembersCount,
      isLoading: false,
      tableLoading: false
    })
  },
  initialState
);
